import { CustomSelect } from '~/components/ui/custom-select'
import { scaleLabel } from '~/components/assessment/labels'
import type { AssessmentResponse } from '~/api/types'

/** 유지하기 화면의 선택된 평가 요약 카드. */
export function AssessmentSideCard({
    assessments,
    selectedAssessment,
    selectedId,
    onSelect,
}: {
    assessments: AssessmentResponse[]
    selectedAssessment?: AssessmentResponse
    selectedId: string
    onSelect(value: string): void
}) {
    return (
        <section className='border-border bg-card rounded-md border p-4'>
            <h2 className='text-foreground text-sm font-semibold'>대상 평가</h2>
            <CustomSelect
                value={selectedId}
                onValueChange={onSelect}
                ariaLabel='대상 평가 선택'
                containerClassName='mt-3'
                options={assessments.map((item) => ({
                    value: item.id,
                    label: `${item.title} (${scaleLabel(item.scale)})`,
                }))}
            />
            {selectedAssessment ? (
                <dl className='mt-3 grid gap-2 text-xs'>
                    <div className='flex justify-between gap-3'>
                        <dt className='text-muted-foreground'>분류</dt>
                        <dd className='text-foreground font-medium'>
                            {selectedAssessment.classification ?? '분류 미정'}
                        </dd>
                    </div>
                    <div className='flex justify-between gap-3'>
                        <dt className='text-muted-foreground'>규모</dt>
                        <dd className='text-foreground font-medium'>
                            {scaleLabel(selectedAssessment.scale)}
                        </dd>
                    </div>
                    <div className='grid gap-1'>
                        <dt className='text-muted-foreground'>업종</dt>
                        <dd className='text-foreground line-clamp-2 font-medium'>
                            {selectedAssessment.industry ?? '업종 미정'}
                        </dd>
                    </div>
                </dl>
            ) : null}
        </section>
    )
}
